// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"bc2486cf","133":"7f8675fd","182":"74685a76"}[chunkId] + ".chunk.js";
};